export const getAssetURL = (data, assetId) => {
  const currentAsset = data?.includes?.Asset?.find(
    (asset) => asset?.sys?.id === assetId
  );
  return currentAsset?.fields?.file?.url;
};

export const getEntry = (data, assetId) => {
  return data?.includes?.Entry?.find((asset) => asset?.sys?.id === assetId);
};
